import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import './NavPanelSkeleton.scss';

const NavPanelSkeleton: FC = () => (
  <div className="NavPanelSkeleton">
    <Skeleton count={4} height="1.5rem" />
  </div>
);

export default NavPanelSkeleton;
